module.exports = __webpack_public_path__ + "static/media/bg_crocodile_game_wood.152aac64.png";